import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import SectionTitle from '../common/SectionTitle';
import Button from '../common/Button';
import { staggerContainer, staggerItem } from '../../utils/animations';
import { ABOUT_CONTENT } from '../../utils/constants';

const AboutSection = () => {
  const navigate = useNavigate();

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <SectionTitle 
          title="ABOUT US" 
          align="center"
        />

        <motion.div
          className="max-w-4xl mx-auto text-center"
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
        >
          <motion.p
            className="text-lg md:text-xl text-dark leading-relaxed mb-8"
            variants={staggerItem}
          >
            CrafCoat Solutions is dedicated to providing superior painting, coating, and finishing services. 
            We combine artistic craftsmanship with technical expertise to deliver luxurious and 
            durable finishes to each client's vision.
          </motion.p>

          <motion.div
            className="grid grid-cols-1 md:grid-cols-3 gap-8 my-16"
            variants={staggerContainer}
          >
            {/* Interior Painting */}
            <motion.div
              className="text-center"
              variants={staggerItem}
            >
              <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center">
                <svg
                  className="w-full h-full text-primary-brown"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={1.5}
                    d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
                  />
                </svg>
              </div>
              <h3 className="text-xl font-serif text-dark mb-3">Paint Finishes</h3>
              <p className="text-dark-light text-sm leading-relaxed">
                High-quality interior and exterior paint applications for refined living environments.
              </p>
            </motion.div>

            {/* Protective Coatings */}
            <motion.div
              className="text-center"
              variants={staggerItem}
            >
              <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center">
                <svg
                  className="w-full h-full text-primary-brown"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={1.5}
                    d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
                  />
                </svg>
              </div>
              <h3 className="text-xl font-serif text-dark mb-3">Protective Coatings</h3>
              <p className="text-dark-light text-sm leading-relaxed">
                Long-lasting protective coating solutions for various surfaces.
              </p>
            </motion.div>

            {/* Decorative Finishes */}
            <motion.div
              className="text-center"
              variants={staggerItem}
            >
              <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center">
                <svg
                  className="w-full h-full text-primary-brown"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={1.5}
                    d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01"
                  />
                </svg>
              </div>
              <h3 className="text-xl font-serif text-dark mb-3">Decorative Finishes</h3>
              <p className="text-dark-light text-sm leading-relaxed">
                Custom decorative and textured finishes for unique aesthetics.
              </p>
            </motion.div>
          </motion.div>

          <motion.div variants={staggerItem}>
            <Button 
              variant="primary" 
              size="large"
              onClick={() => navigate('/about')}
            >
              Learn More About Us
            </Button>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default AboutSection;